import React from 'react';
import {getPublicImagePath, notifySuccess, SubscriptionForm, useAppState} from '@nutastic/nutastic-react-app';

const Footer = () => {
    const { socialMedia = [] } = useAppState();
    const onSubscriptionSubmit = () => {
        notifySuccess('Thanks you for subscribing to Especially For You Ministry. We are excited to connnect with you!');
    };

    const getSocialClassType = type => {
        if(type === "facebook") return "facebook-square";
        else return type;
    };

    return <footer className="footer">
        <div className="subscriptionBox background-light-green">
            <div className="container">
                <div className="subscriptionBox__form">
                    <h4>Enter your information to subscribe to Especially For You <i>By Joslin</i>:</h4>
                    <SubscriptionForm onSubmit={onSubscriptionSubmit} />
                </div>
            </div>
        </div>
        <div className="container">
            <span className="copyright">Copyright &copy; 2022. Especially For You <i>By Joslin</i></span>
            <img src={getPublicImagePath('logo-footer.png')} alt="Especially For You, By Joslin | White Logo" />
            <div className="footer__social">
                { socialMedia.map( s =>  <a href={s.url} target="_blank"><i className={`fa fa-${getSocialClassType(s.type)}`} /></a> ) }
            </div>
        </div>
    </footer>;
};

export default Footer;
